import * as Yup from 'yup';

export const addressValidation = Yup.string().matches(
  /^[\da-zA-Z#,. -]*$/,
  'Address can only contain numbers, letters, spaces, and the characters (#-,.)'
);
